module.exports = {"512022001":"天池街道","512022002":"南塔街道","512022101":"石佛镇","512022102":"回澜镇","512022103":"石湍镇","512022104":"童家镇","512022105":"宝林镇","512022106":"大佛镇","512022107":"良安镇","512022108":"金顺镇","512022109":"中和场镇","512022110":"劳动镇","512022111":"中天镇","512022112":"佛星镇","512022113":"蟠龙镇","512022114":"东山镇","512022115":"通旅镇","512022116":"高寺镇","512022117":"龙门镇","512022118":"盛池镇","512022204":"双河场乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/512022.json
// module id = 2527
// module chunks = 0